import {IntermediatePart} from "../../intermediatePart";

export default class Lamp extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'lamp';
    this.partName = 'Lamp';
    this.translateId = "visualizer.bathroom.shower.lamp";
    this.canBeDisabled = true;
  }

}
